// extracted by mini-css-extract-plugin
export default {"nav_2":"index-module_nav_2_-kjYb","navTitle":"index-module_navTitle_KQSZw","navList":"index-module_navList_W8RBc","navItem":"index-module_navItem_2a2hV"};